"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEmptyResultModalClick = exports.EmptyResultsModalTarget = exports.EmptyResultsModalSource = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var EmptyResultsModalSource;
(function (EmptyResultsModalSource) {
    EmptyResultsModalSource["HOTELS"] = "no-packages";
    EmptyResultsModalSource["PACKAGES"] = "no-hotels";
})(EmptyResultsModalSource || (exports.EmptyResultsModalSource = EmptyResultsModalSource = {}));
var EmptyResultsModalTarget;
(function (EmptyResultsModalTarget) {
    EmptyResultsModalTarget["ADAPT_SEARCH"] = "adapt-search";
    EmptyResultsModalTarget["SWITCH_TO_HOTELS"] = "switch-to-hotels";
    EmptyResultsModalTarget["SWITCH_TO_PACKAGES"] = "switch-to-packages";
})(EmptyResultsModalTarget || (exports.EmptyResultsModalTarget = EmptyResultsModalTarget = {}));
const trackEmptyResultModalClick = ({ source, target, }) => (0, libs_tracking_events_1.track)({
    event: `🚀 noResultsModal.choose`,
    eventMetadata: {
        source,
        target,
    },
    _clear: true,
});
exports.trackEmptyResultModalClick = trackEmptyResultModalClick;
//# sourceMappingURL=trackEmptyResultsModal.js.map